import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withFirebase } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { Container, Nav, Navbar, NavbarBrand } from 'shards-react';
import { closeModal, openModal } from '../../common/modals/modalActions';
import { toggleSidebar } from '../../layout/MainSidebar/sidebarActions';
import { loginUser } from '../../pages/Auth/authActions';
import SignInMenu from '../Menu/SignInMenu';
import SignoutMenu from '../Menu/SignoutMenu';
import './Navbar.scss';
var packageJson = require('../../../../package.json');

const mapState = state => ({
  auth: state.firebase.auth,
  profile: state.firebase.profile
});

const actions = {
  loginUser,
  openModal,
  closeModal,
  toggleSidebar
};

class NavbarComp extends Component {
  state = {
    collapseOpen: false,
    dropdownOpen: false
  };

  toggleNavbar = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };

  handleSignIn = () => {
    this.props.loginUser();
    // console.log('sign in');
    //this.props.history.push("/dashboard");
  };

  handleSignOut = () => {
    this.props.firebase.logout();
    this.props.history.push('/login');
  };
  toggleNavbar() {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  }

  handleRegister = () => {
    this.props.history.push('/register');
  };

  toggleDropdown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  render() {
    const { auth, profile, openModal, closeModal, toggleSidebar } = this.props;
    const authenticated = auth.isLoaded && !auth.isEmpty;
    const classes = classNames('main-navbar', false && 'sticky-top');

    return (
      <div className={classes}>
        <Container className='p-0' fluid>
          <Navbar
            type='dark'
            theme='primary'
            className='align-items-center flex-md-nowrap p-0'
          >
            <NavbarBrand className='text-white d-none d-md-flex ml-2' href='/'>
              NCCC
            </NavbarBrand>
            {authenticated ? (
              <nav className='nav'>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  onClick={toggleSidebar}
                  className='nav-link-icon toggle-sidebar d-sm-inline d-md-none d-lg-none text-center text-white'
                >
                  <i className='material-icons'>&#xE5D2;</i>
                </a>
              </nav>
            ) : (
              ''
            )}
            <div className='main-navbar__search w-100 d-none d-md-flex d-lg-flex' />
            <div className="text-white" >{packageJson.version}</div>
            <Nav navbar className='flex-row ml-2'>
              {authenticated ? (
                <SignoutMenu
                  signOut={this.handleSignOut}
                  auth={auth}
                  profile={profile}
                  toggleDropdown={this.toggleDropdown}
                  dropdownOpen={this.state.dropdownOpen}
                  collapseOpen={this.state.collapseOpen}
                  toggleNavbar={this.toggleNavbar}
                  toggleSidebar={toggleSidebar}
                />
              ) : (
                <SignInMenu
                  signIn={this.handleSignIn}
                  register={this.handleRegister}
                  openModal={openModal}
                  closeModal={closeModal}
                  toggleDropdown={this.toggleDropdown}
                  dropdownOpen={this.state.dropdownOpen}
                  collapseOpen={this.state.collapseOpen}
                  toggleNavbar={this.toggleNavbar}
                />
              )}
            </Nav>
          </Navbar>
        </Container>
      </div>
    );
  }
}
export default withRouter(withFirebase(connect(mapState, actions)(NavbarComp)));
